import { PixelMeasurements } from './pixel-measurements.model';

export class PixelDimensions2D extends PixelMeasurements {
  public readonly width: string;
  public readonly height: string;

  constructor(width: number, height: number, centimeterToPixelRatio: number) {
    super(centimeterToPixelRatio);
    this.width = this.toPixels(width);
    this.height = this.toPixels(height);
  }

  get widthNumber(): number {
    return parseInt(this.width.slice(0, -2), 10);
  }

  get heightNumber(): number {
    return parseInt(this.height.slice(0, -2), 10);
  }
}
